import { withStyles } from "@material-ui/core/styles";
import DialogLoginAs from "./DialogLoginAs";
import styles from "./styles";

export default withStyles(styles)(DialogLoginAs);
